import React, { useState } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  MenuItem,
  FormGroup,
  Checkbox,
  FormControlLabel,
  Popover,
  CircularProgress,
  Button,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "../../../assets/filter.svg";
import Buttons from "../../../components/Controls/Buttons/Button";
import Label from "../../../components/Label/Label.jsx";
import TabsNav from "../../analytics/header/BatchTabsNav";
import "./review.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function LimitsListHeader({
  text,
  buttonText,
  onButtonClick,
  filterOptionsGroup1,
  filterOptionsGroup2,
  selectedFilters,
  handleCheckboxChange,
  isButton = false,
  handleSearch,
  search,
  handleClickFilter,
  anchorFilter,
  handleCloseFilter,
  selectedCheck,
  onDownloadClick,
  viewAuditLogs,
  viewLogs,
  onBackClick,
  placeholder = "Search",
  is_multi_approve = false,
  multipleApprove,
  approveMulti,
  downloadExcelTemp
}) {
  const openFilter = Boolean(anchorFilter);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{ borderBottom: "1px solid #e0e0e0", py: 1, px: 1, gap: 2 }}
    >
      {" "}
      {viewLogs ? (
        <>
          {" "}
          <Button
            startIcon={<ArrowBackIcon />}
            sx={{
              textTransform: "none",
              borderRadius: "20px !important",
              paddingX: 2,
              paddingY: 0.2,
              backgroundColor: "#E9EAEB",
              color: "Black",
            }}
            onClick={onBackClick}
          >
            Back
          </Button>
        </>
      ) : (
        <>
          <TabsNav />
        </>
      )}
      <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
        <Box>
          <TextField
            size="small"
            placeholder={placeholder}
            variant="outlined"
            value={search}
            onChange={handleSearch}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          <Box display="flex" alignItems="center" gap={1}>
            {/* <Buttons
            colors={"success"}
            text={"Approve"}
            disabled={!selectedCheck?.length > 0}
          /> */}
          </Box>
          <Button
            onClick={handleClickFilter}
            startIcon={<img src={FilterListIcon} alt="Filter" />}
            sx={{
              color: "black",
              textTransform: "none",
              fontSize: 14,
              fontWeight: 400,
            }}
          >
            Filter
          </Button>
          <Popover
            id={1}
            open={openFilter}
            anchorEl={anchorFilter}
            onClose={handleCloseFilter}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            sx={{ mt: 1 }}
          >
            <Box p={2} minWidth={150}>
              {/* <Typography fontSize={14} mb={1}>
              Filter By:
            </Typography> */}

              <FormGroup>
                {filterOptionsGroup1?.map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={selectedFilters?.includes(option)}
                        onChange={() => handleCheckboxChange(option)}
                      />
                    }
                    label={option}
                  />
                ))}
                {filterOptionsGroup2?.length > 0 && (
                  <hr style={{ width: "100%" }}></hr>
                )}
                {filterOptionsGroup2?.map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={selectedFilters?.includes(option)}
                        onChange={() => handleCheckboxChange(option)}
                      />
                    }
                    label={option}
                  />
                ))}
              </FormGroup>
            </Box>
          </Popover>

          {is_multi_approve && <Button
            variant={"contained"}
            disabled={!selectedCheck?.length > 0 || approveMulti?.loading}
            startIcon={
              approveMulti?.loading ? (
                <CircularProgress size={16} sx={{ color: "#fff" }} />
              ) : (''
              )
            }
            sx={{
              // backgroundColor: "#154D8F",
              textTransform: "none",
              // "&:hover": { backgroundColor: "#1565c0" },
              fontSize: 14,
              fontWeight: 400,
            }}
            onClick={multipleApprove}
          >
            Approve
          </Button>
          }
          {isButton && (
            <>
              {" "}
              <Button
                variant={!viewLogs ? "outlined" : "contained"}
                sx={{
                  // backgroundColor: "#154D8F",
                  textTransform: "none",
                  // "&:hover": { backgroundColor: "#1565c0" },
                  fontSize: 14,
                  fontWeight: 400,
                }}
                onClick={viewAuditLogs}
              >
                Audit Trail
              </Button>
              <Button
                variant="contained"
                startIcon={
                  downloadExcelTemp?.loading ? (
                    <CircularProgress size={16} sx={{ color: "#fff" }} />
                  ) : (
                    <DownloadIcon />
                  )
                }
                onClick={onDownloadClick}
                sx={{
                  backgroundColor: "#3882DB",
                  textTransform: "none",
                  minHeight: "36px",
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
              >
                {downloadExcelTemp?.loading ? "Template Downloading" : "Template Download"}
              </Button>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={onButtonClick}
                sx={{
                  backgroundColor: "#3882DB",
                  textTransform: "none",
                  minHeight: "36px",
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
              >
                {buttonText}
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
